import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Stack, Typography } from "@mui/material";

const CardActiveCorporate = ({ variant, user_role, item }) => {
    const secureThumbnail =
        item?.thumbnail_url?.startsWith("http://")
            ? item?.thumbnail_url.replace("http://", "https://")
            : item?.thumbnail_url;
    const [hide, setHide] = useState(true);
    const navigate = useNavigate();

    const cleanDescription = item?.description?.replace(/(<([^>]+)>)/gi, "") || "";
    const isLongDescription = cleanDescription.length > 250;

    const handleOpenConsole = (id) => {
        const hasVM = item?.VM_access;
        const hasTTX = item?.ttx_access;

        // only TTX access
        if (!hasVM && hasTTX) {
            navigate(`/scenario-console-ttx/${id}`, {
                state: {
                    scenarioId: item?.id,
                    participantId: item?.participant_id,
                },
            });
            return;
        }


        navigate(`/scenario-console/${id}`, {
            state: {
                scenarioId: item?.id,
                participantId: item?.participant_id,
            },
        });
    };


    const hasVM = item?.VM_access;
    const hasTTX = item?.ttx_access;
    const showTTXOnly = !item?.VM_access && item?.ttx_access;



    return (
        <Stack

            direction="row"
            style={{
                maxHeight: "fit-content",
                justifyContent: "space-between",
                width: "100%",
                gap: 24,
                backgroundColor: "#16181F",
                borderRadius: "12px",
                marginBottom: 24,
                filter: item?.display === false && `blur(0.8px)`,
            }}
        >

            <Stack direction="row" sx={{ flex: 1, minWidth: 0 }}>
                {/* image */}
                <Box
                    sx={{
                        width: "255px",
                        minWidth: "255px",
                        maxWidth: "255px",
                        height: "170px",
                        minHeight: "170px",
                        maxHeight: "170px",
                        flexShrink: 0,
                        alignSelf: "flex-start",
                        overflow: "hidden",
                        borderRadius: "12px 0 0 12px",
                        backgroundColor: "#0d0e12",
                    }}
                >
                    <img
                        // src={secureThumbnail}
                        src={item?.thumbnail_url}
                        alt="image"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            display: "block",
                        }}
                    />
                </Box>

                {/* details */}
                <Stack
                    justifyContent="space-around"
                    style={{ padding: 12 }}
                    sx={{ flex: 1, minWidth: 0 }}
                >
                    <Stack
                        direction="row"
                        alignItems="center"
                        gap={2}
                        marginVertical={2}
                        flexWrap="wrap"
                    >
                        <Typography variant="h2">{item?.name}</Typography>

                        <Typography
                            variant="body3"
                            sx={pillStyle}
                        >
                            {item?.severity_name}
                        </Typography>

                        <Typography
                            variant="body3"
                            sx={pillStyle}
                            noWrap
                        >
                            {item?.points} points
                        </Typography>


                        {item?.category_name && <Typography
                            variant="body3"
                            sx={pillStyle}
                            noWrap
                        >
                            {item?.category_name}
                        </Typography>}

                        <Typography
                            variant="body3"
                            sx={pillStyle}
                            noWrap
                        >
                            {item?.type_name}
                        </Typography>

                        {item?.ttx_enabled && (
                            <Typography
                                variant="body3"
                                sx={pillStyle}
                                noWrap
                            >
                                TTX enabled
                            </Typography>
                        )}


                        {/* {(hasVM || hasTTX) && (
                            <Typography
                                variant="body3"
                                sx={pillStyle}
                                noWrap
                            >
                                {hasVM && hasTTX
                                    ? "VM + TTX Access"
                                    : hasVM
                                        ? "Only VM Access"
                                        : "Only TTX Access"}
                            </Typography>
                        )} */}








                    </Stack>

                    {/* description */}
                    <Stack sx={{ width: "100%" }}>
                        <Typography
                            variant="h5"
                            sx={{
                                color: "#BCBEC1",
                                wordBreak: "break-word",
                            }}
                        >
                            {isLongDescription && hide
                                ? `${cleanDescription.substring(0, 250)}...`
                                : cleanDescription}
                        </Typography>

                        {isLongDescription && (
                            <Typography
                                variant="h5"
                                sx={readMoreStyle}
                                onClick={() => setHide(!hide)}
                            >
                                {hide ? "Read More" : "Read Less"}
                            </Typography>
                        )}
                    </Stack>
                </Stack>
            </Stack>

            {/* right button */}
            <Stack
                justifyContent="center"
                alignItems="center"
                paddingRight={3}
                sx={{ flexShrink: 0 }}
            >
                <Typography
                    onClick={() => handleOpenConsole(item?.id)}
                    sx={{
                        cursor: "pointer",
                        height: "fit-content",
                        padding: "4px 16px",
                        margin: "24px",
                        minWidth: "150px",
                        background: "linear-gradient(45deg, rgb(3, 104, 140) 0%, rgb(8, 190, 208) 100%)",
                        borderRadius: "16px",
                        textAlign: "center",
                        color: "rgb(234, 234, 235)",
                    }}
                >
                    Get Console
                </Typography>
            </Stack>
        </Stack >
    );
};

const pillStyle = {
    color: "#BCBEC1",
    backgroundColor: "#242833",
    borderRadius: "16px",
    padding: "4px 16px",
};

const readMoreStyle = {
    cursor: "pointer",
    color: "#0FF",
};

export default CardActiveCorporate;